import { useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import {
  CREATE_TRACKING_SHIPMENT,
  Delete_District,
  Edit_Trip_Query,
  getShipmentTrackingById,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import { MyShipMentTrack_Inputs } from "./AddShipment.Config";
import { useModalContext } from "../../Reactportal/ModalContext";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import { handleFormReset, updateValueForm } from "../../FormInputSectionComponent/formUtils";

const AddMyShipMentTracking = ({ show, TypeOfPortal, submitType, ParentPortalCloseFunction }) => {
  const formRef = useRef({});
  const [FormData, setFormdata] = useState<any>({});
  const Form_Key = "Shipment_Tracking";
  const { pushModal, popModal } = useModalContext();
  const [toggle, settoggle] = useState(show ? show : false);
  const dispatch = useDispatch();
  const [selectedRows, setSelectedRows] = useState([]);
  const fielddataRedux = useSelector((store: any) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.[Form_Key]?.Selected_Row;
  const [allFieldsData, setAllFieldsData] = useState({});
  const FormDataFromRedux = useSelector((store: any) => store?.FormDataReducer);
  const [formErrors, setFormErrors] = useState({});

  // Q & M
  const [CreatingData, { loading: createShipmentTrackLoading }] = useMutation(CREATE_TRACKING_SHIPMENT, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [geShipmentTrackById, { loading: getByIdShipmentTrackLoading }] = useLazyQuery(getShipmentTrackingById, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [EditingData, { loading: editShipmentTrackLoading }] = useMutation(Edit_Trip_Query, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [DeletingData, { loading: deleteShipmentTrackLoading }] = useMutation(Delete_District, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const ShipmentTrackLoader =
    createShipmentTrackLoading || getByIdShipmentTrackLoading || editShipmentTrackLoading || deleteShipmentTrackLoading;

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  useEffect(() => {
    setSelectedRows(fielddataRedux?.[Form_Key]?.Selected_Rows);
  }, [fielddataRedux]);

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  useEffect(() => {
    if (!TypeOfPortal.includes("Add")) {
      geShipmentTrackById({
        variables: {
          id: fielddata?._id,
        },
      }).then(({ data }) => {
        console.log(data);
        let ShipmentTrackData = { ...data?.getTripTrackById };
        const updatedShipmentTrackData = {
          Loading_Point: ShipmentTrackData.Loading_City,
          Unloading_Point: ShipmentTrackData.Unloading_City,
          Driver_Mobile: ShipmentTrackData.Driver_Number,
          Vehicle_No: ShipmentTrackData.Vehicle_No,
          Track_For: `${ShipmentTrackData.Track_For} ${ShipmentTrackData.Track_For === 1 ? "Day" : "Days"}`,
          _id: ShipmentTrackData._id,
        };
        dispatch({
          type: "StoreMasterData",
          payload: {
            formkey: Form_Key,
            data: {
              Loading_Point: {
                Search_Value: ShipmentTrackData.From_Location || ShipmentTrackData.Loading_City,
                formatted_address: ShipmentTrackData.Loading_Address_Line_1,
                Landmark: ShipmentTrackData.Loading_Landmark,
                location: {
                  coordinates: [ShipmentTrackData.Loading_Longitude, ShipmentTrackData.Loading_Latitude],
                },
                Pincode: ShipmentTrackData.Loading_Pincode,
                State: ShipmentTrackData.Loading_State,
              },
              UnLoading_Point: {
                Search_Value: ShipmentTrackData.To_Location || ShipmentTrackData.Unloading_City,
                formatted_address: ShipmentTrackData.Unloading_Address_Line_1,
                Landmark: ShipmentTrackData.Unloading_Landmark,
                location: {
                  coordinates: [ShipmentTrackData.Unloading_Longitude, ShipmentTrackData.Unloading_Latitude],
                },
                Pincode: ShipmentTrackData.Unloading_Pincode,
                State: ShipmentTrackData.Unloading_State,
              },
            },
          },
        });
        setAllFieldsData(updatedShipmentTrackData);
        updateValueForm(formRef, updatedShipmentTrackData);
      });
    }
  }, [fielddata]);

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key)
    }
  }, []);


  //Disable fields use
  useEffect(() => {
    const inputNames = ["Loading_Point", "Unloading_Point", "Vehicle_No", "Track_For"];

    inputNames.forEach((name) => {
      const input = document.getElementsByName(name);
      if (input.length > 0 && !TypeOfPortal?.includes("Add")) {
        const lastInput = input[input.length - 1] as HTMLInputElement;
        lastInput.disabled = true;
      }
    });
  }, []);

  const { executeOperation } = useSubmitOperation();
  const operationType = TypeOfPortal;

  const Loading_Point = FormDataFromRedux?.MasterData?.[Form_Key]?.Loading_Point;
  const UnLoading_Point = FormDataFromRedux?.MasterData?.[Form_Key]?.Unloading_Point;

  let formData = {
    Driver_Number: FormData?.Driver_Mobile,
    Vehicle_No: FormData?.Vehicle_No,
    Track_For: FormData?.Track_For
      ? FormData.Track_For.match(/\d+/)
        ? Number(FormData.Track_For.match(/\d+/)[0])
        : ""
      : "",

    From_Location: Loading_Point?.Search_Value,
    Loading_Address_Line_1: Loading_Point?.formatted_address,
    Loading_City: Loading_Point?.Search_Value,
    Loading_Landmark: Loading_Point?.Landmark,
    Loading_Latitude: Number(Loading_Point?.location?.coordinates?.[1]),
    Loading_Longitude: Number(Loading_Point?.location?.coordinates?.[0]),
    Loading_Pincode: Loading_Point?.Pincode,
    Loading_State: Loading_Point?.State,

    To_Location: UnLoading_Point?.Search_Value,
    Unloading_Address_Line_1: UnLoading_Point?.formatted_address,
    Unloading_City: UnLoading_Point?.Search_Value,
    Unloading_Landmark: UnLoading_Point?.Landmark,
    Unloading_Latitude: Number(UnLoading_Point?.location?.coordinates?.[1]),
    Unloading_Longitude: Number(UnLoading_Point?.location?.coordinates?.[0]),
    Unloading_Pincode: UnLoading_Point?.Pincode,
    Unloading_State: UnLoading_Point?.State,
  };

  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, formData, selectedRows);

  const mutationFunctions = {
    CreatingData,
    EditingData,
    DeletingData,
  };

  const submit = async (closeAction: string) => {
    const mutationFunction = getMutationFunction(operationType, mutationFunctions);
    const executeOperationFunction = () =>
      executeOperation({
        operationType,
        data: formData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,
        EditRefresh: false,
        PageName: Form_Key,
      });
    handleFormSubmission(executeOperationFunction, {
      dispatch,
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: () => handleFormReset(formRef),
      onSuccess: () => { },
      onError: (error: any) => {
        ErrorToast((error as Error).message);
      },
    });
  };

  const Closeformfunction = () => {
    popModal(Form_Key);
    ParentPortalCloseFunction();
    settoggle(false);
    setAllFieldsData({});
    ClearSpecificForm(dispatch, Form_Key);
  };

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };



  function handleSaveAndClose() {
    if (TypeOfPortal === "Add") {
      Validate_handleSubmit(SaveAndCloseForAdd);
    } else {
      Validate_handleSubmit(submit);
    }
  }
  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={false}
      submitform={() => {
        Validate_handleSubmit(submit);
      }}
      submitType={submitType}
      Form_key={Form_Key}
      TypeOfPortal={TypeOfPortal}
      SaveAndClose={() => {
        handleSaveAndClose();
      }}
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      loadingState={ShipmentTrackLoader}
    />
  );
  return (
    <>
      <div>
        <Reactportal
          FoooterContent={footerContent}
          open={toggle}
          onClose={Closeformfunction}
          TypeOfPortal={TypeOfPortal + " ShipMent Track"}
        >
          <>
            {ShipmentTrackLoader && <div className="loader-line-div" />}
            <div className="formContainer">
              {MyShipMentTrack_Inputs.map((e, i) => {
                return (
                  <div key={e.id} className="FormSectionParent">
                    <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                    <div className="FormSection insidecontainer">
                      <FormInputSectionComponent
                        inputfields={e.fields}
                        Type={e.name}
                        formkey={Form_Key}
                        onErrorsChange={handleErrorsChange}
                        formRef={formRef}
                        TypeOfPortal={TypeOfPortal}
                        onhandleFormikChange={HanldeChangeonForm}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        </Reactportal>
      </div>
    </>
  );
};
export default AddMyShipMentTracking;
